import { IconButton } from '@atlaskit/button/new';
import CloseIcon from '@atlaskit/icon/core/cross';
import { type JSX } from 'react/jsx-runtime';

export const CloseButton = ({ onClick }: { onClick: () => void }): JSX.Element => {
	return (
		<IconButton
			appearance="subtle"
			icon={(iconProps) => <CloseIcon {...iconProps} />}
			label="Close Flag"
			onClick={onClick}
			spacing="compact"
		/>
	);
};
